<template>
  <div class="app-container">
    <div class="toolbar">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="巡检点" prop="name">
          <el-input
              v-model="queryParams.name"
              placeholder="请输入巡检点"
              clearable
              @keyup.enter.native="handleQuery('up')"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery('up')">搜索</el-button>
          <el-button type="warning" :size="size" @click="QrcodeBatch">批量生成二维码</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <div class="addToolbar">
        <el-button type="primary" :size="size" @click="handleAdd">新增</el-button>
      </div>
      <el-table :data="tableData.list" stripe height="450" :size="size" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="companyName" label="所属公司" width="250" show-overflow-tooltip/>
        <el-table-column prop="name" label="巡检点名称" width="250" show-overflow-tooltip/>
        <el-table-column prop="locationName" label="位置" width="250" show-overflow-tooltip/>
        <el-table-column prop="createTime" label="创建时间" minwidth="250" show-overflow-tooltip/>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <el-button type="info" @click="scEeWeiMaDc(scope.row)" :size="size">生成二维码</el-button>
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar" style="padding: 10px" v-if="tableData.total > 0">
        <pagination
            :total="tableData.total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="handleQuery"
        />
      </div>
    </div>
    <el-drawer :title="title" :visible.sync="openDrawer" destroy-on-close class="editdrawer OA" size="32%">
      <div class="xiangqing">
        <el-form
            :model="form"
            :rules="formRules"
            label-width="120px"
            ref="form"
            label-position="left"
            style="margin-bottom: 45px"
            :disabled="title == '详情'"
        >
          <el-form-item label="巡检点名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入巡检点名称"/>
          </el-form-item>

          <el-form-item label="巡检点位置" prop="location">
            <el-input v-model="form.location" placeholder="请选择位置" readonly @click.native="openMap(form)"/>
          </el-form-item>
          <el-form-item label="巡检点位置" prop="locationName">
            <el-input type="textarea" autosize v-model="form.locationName" placeholder="请输入巡检点名称"/>
          </el-form-item>
          <el-form-item label="打卡人员设置:">
            <el-input placeholder="请选择打卡人" v-model="form.userName">
              <el-button slot="append" icon="el-icon-search" @click="openTree()"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="打卡模板设置:">
            <el-select v-model="form.templateId" placeholder="请选择打卡模板" style="width: 100%">
              <el-option
                  v-for="(column, index) in templateList"
                  :key="index"
                  :label="column.templateName"
                  :value="column.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="打卡时间区间:">
            <el-time-picker
                is-range
                v-model="startBeginEnd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="打卡浮动时间:" v-show="startBeginEnd!=null">
            <el-input-number v-model="form.floatingTime" controls-position="right" :min="1" :max="60"></el-input-number>
            <span style="font-size: 14px;color: #737373;margin-left: 10px">分钟<span
                style="color: #c60000;margin-left: 10px"></span></span>
          </el-form-item>
          <el-form-item label="打卡巡视时间:" v-show="startBeginEnd!=null">
            <el-input-number v-model="form.intervalTime" controls-position="right" :min="1" :max="60"></el-input-number>
            <span style="font-size: 14px;color: #737373;margin-left: 10px">分钟<span
                style="color: #c60000;margin-left: 10px">(间隔多久打卡一次)</span></span>
          </el-form-item>
          <el-form-item label="打卡提示时间:" v-show="startBeginEnd!=null">
            <el-input-number v-model="form.promptTime" controls-position="right" :min="1" :max="60"></el-input-number>
            <span style="font-size: 14px;color: #737373;margin-left: 10px">分钟<span
                style="color: #c60000;margin-left: 10px">(提前多久提示一次)</span></span>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" v-if="title != '详情'">
          <el-button @click="openDrawer = false">取消</el-button>
          <el-button :loading="loading" type="primary" @click="submitForm()">保存</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 定位经纬度 -->
    <el-dialog
        title="标记坐标点"
        width="80%"
        height="100%"
        :visible.sync="dialogVisibles"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        class="map siandaoinfoWork"
    >
      <txMapDraw
          ref="child"
          @saveTxMapPoint="getMsgFormSon"
          :marker="form.location"
          :type="enterType"
      />
<!--      <mapUpdata ref="child" :Coordinate="form.location" :type="enterType" @func="getMsgFormSon"/>-->
    </el-dialog>

    <div style="margin-top: 20px; display: none">
      <!--存放二维码-->
      <div class="qrcode" id="qrcode" ref="ImgUrl" style="margin-top: 20px"></div>
      <canvas></canvas>
    </div>
    <div style="display: none">
      <canvas id="main" width="690" height="905">请使用支持HTML5的浏览器</canvas>
    </div>
    <tree @update="closeTree" @sendList="getSelectList($event)" :open="treevisible" :list="selectList"
          v-if="treevisible" :companyId="EId" :url="url"></tree>
  </div>
</template>

<script>
import tree from "@/views/shop/zhTree.vue";
import {
  sysInspectionList,
  sysInspectionAdd,
  sysInspectionUpdate,
  sysInspectionDelete,
  listTemplate
} from '@/api/clockIn'
import mapUpdata from '@/components/mapUpdata'
import {fabric} from 'fabric'
import QRCode from 'qrcodejs2'
import FileSaver from 'file-saver'
import JSZip from 'jszip'
import codejsmb from './components/codeJss'
import bgImage from '@/assets/image/二维码背景3.png'
import txMapDraw from "@/components/txMapDraw/index.vue";
import axios from 'axios'
import moment from "moment";

export default {
  components: {
    tree,
    txMapDraw,
    mapUpdata
  },
  data() {
    return {
      url: this.$route.query.url,
      EId: this.$route.query.EId,
      treevisible: false,
      selectList: [],
      peopleList: [],
      startBeginEnd: null,
      templateList: [],
      piLiang: false,
      QRCodeURL: [],
      bgImage: bgImage,
      canvasObj: undefined,
      faBIds: [],
      size: 'mini',
      title: '',
      loading: false,
      openDrawer: false,
      dialogVisibles: false,

      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      },
      tableData: {},
      form: {},
      formRules: {
        name: [{required: true, message: '请输入巡检点名称', trigger: 'blur'}],
        location: [{required: true, message: '请选择位置', trigger: 'change'}],
      },
      enterType: '',
    }
  },
  mounted() {
    this.handleQuery()
    //查询打卡模板
    this.selectTemplate();
    this.canvasObj = new fabric.Canvas('main', {
      isDrawingMode: false, //设置是否可以绘制
      selectable: false, //设置是否可以选中拖动  fabric提供的
      selection: false,
      fireRightClick: false, // 启用右键，button的数字为3
      stopContextMenu: false, // 禁止默认右键菜单
    })
  },
  methods: {
    // 接收 子组件传递过来 的勾选人员数组
    getSelectList(list) {
      this.selectList = list;
      this.peopleList = list;
      let names = ''
      list.forEach(item => {
        names += item.name + ","
      })
      this.form.userName = names;
    },
    closeTree(e) {
      this.treevisible = false;
      console.log(e)
    },
    openTree() {
      this.treevisible = true;
    },
    selectTemplate() {
      let params = {
        pageNum: 1,
        pageSize: 99,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId
      }
      listTemplate(params).then((res) => {
        if (res.code == 200) {
          this.templateList = res.rows;
        }
      })

    },
    // 查询
    handleQuery(part) {
      if (part == 'up') {
        this.queryParams.pageNum = 1
      }
      sysInspectionList(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      })
    },
    // 新增
    handleAdd() {
      this.title = '新增'
      this.openDrawer = true
      this.form = {
        id: null,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        name: '',
        locationName: '',
        location: '',
        templateId: '',
        beginTime: '',
        endTime: '',
        intervalTime: '',
        promptTime: '',
        floatingTime: ''
      }
      console.log(this.form)
    },
    // 打开地图标记
    openMap(val) {
        const isEdit = val.location && val.location !== '' && val.location !== '[]'
  this.enterType = isEdit ? 'edit' : 'add'
  
  console.log('打开地图，模式：', this.enterType, '坐标：', val.location)
      this.dialogVisibles = true
      this.form.location = val.location
      setTimeout(() => {
        this.$refs.child.pointData()
      }, 1000)
    },
    // 地图坐标保存
    getMsgFormSon(arr1, arr2, type) {
      console.log(arr1, 'arr1') // 坐标点
      console.log(arr2, 'arr2') // 详细地址 名称
      console.log(type, 'type') // 详细地址 名称
      this.form.location = JSON.stringify([arr1])
      this.form.locationName = arr2
      this.dialogVisibles = false
    },
    // 编辑
    handleEdit(row) {
      this.title = '编辑'
      this.openDrawer = true
      this.form = Object.assign({}, row)
      let data = row.userGroup;
      let name = row.userName?row.userName.split(','):[];
      this.selectList = data? data.split(',').map((item, index) => ({
        userId: item, name:
            name[index]
      })):[]
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除此项吗？', '提示', {}).then(() => {
        sysInspectionDelete({id: row.id}).then((res) => {
          if (res.code === 200) {
            this.$message({message: '删除成功', type: 'success'})
            this.handleQuery()
            this.$refs['form'].resetFields()
          } else {
            this.$message({message: '删除失败, ' + res.msg, type: 'error'})
          }
        })
      })
    },
    // 保存
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          console.log(123)
          if (this.startBeginEnd !== null) {
            this.form.beginTime = moment(this.startBeginEnd[0]).format("HH:mm:ss")
            this.form.endTime = moment(this.startBeginEnd[1]).format("HH:mm:ss");
          }
          let list = [];
          this.peopleList.forEach(item => {
            list.push(item.userId);
          })
          this.form.userGroup = list.toString();
          if (this.form.id != null) {
            sysInspectionUpdate(this.form).then((response) => {
              if (response.code == 200) {
                this.$message({message: '修改成功', type: 'success'})
                this.openDrawer = false
                this.loading = false
                this.handleQuery()
              } else {
                this.loading = false
              }
            })
          } else {
            sysInspectionAdd(this.form).then((response) => {
              if (response.code == 200) {
                this.$message({message: '新增成功', type: 'success'})
                this.openDrawer = false
                this.loading = false
                this.handleQuery()
              } else {
                this.loading = false
              }
            })
          }
        }
      })
    },
    // 选择巡检点
    handleSelectionChange(val) {
      this.faBIds = []
      for (let i = 0; i < val.length; i++) {
        const e = val[i]
        this.faBIds.push(e)
      }
    },
    // 批量打印二维码
    QrcodeBatch() {
      this.cushu = ''
      this.QRCodeURL = []
      this.piLiang = false
      if (this.faBIds.length == 0) {
        this.$message({message: '请选择巡检点', type: 'warning'})
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在生成，请等待...',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        for (let i = 0; i < this.faBIds.length; i++) {
          this.scEeWeiMa(this.faBIds[i])
        }
        setTimeout(() => {
          this.batchQrCodeZip()
          loading.close()
        }, 7000)
        // this.batchQrCodeZip();
      }
    },
    // 单张生成
    scEeWeiMaDc(row) {
      this.piLiang = true
      this.scEeWeiMa(row)
    },
    // 二维码生成
    scEeWeiMa(row) {
      console.log(row.templateId)
      // console.log(res.data);
      //清除之前的二维码
      this.$refs.ImgUrl.innerHTML = ''
      // var url = "https://xajmylapi.anluoyun.cn//upload/images/2022/10/effc9420-6f0.png";
      var url = {
        templateId: row.templateId == null ? '' : row.templateId + '',
        id: row.id + '',
        name: row.name + '',
      }


      // var url = {
      //   t: row.templateId == null ? '' : row.templateId + '',
      //   i: row.id + '',
      //   n: row.name + '',
      // }
      // console.log(url)
      // console.log( encodeURIComponent(JSON.stringify(url)));

      // console.log(url);
      // console.log(url);
      var qrcode = new QRCode(this.$refs.ImgUrl, {
        text: JSON.stringify(url), // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
      this.getDownload(row)
    },
    // 下载二维码
    getDownload(row) {
      var that = this
      // 先找到canvas节点下的二维码图片
      const myCanvas = document.getElementById('qrcode').getElementsByTagName('canvas')
      const img = document.getElementById('qrcode').getElementsByTagName('img')
      // 创建一个a节点
      const a = document.createElement('a')
      // 设置a的href属性将canvas变成png格式
      const imgURL = myCanvas[0].toDataURL('image/jpg')
      const ua = navigator.userAgent
      if (ua.indexOf('Trident') !== -1 && ua.indexOf('Windows') !== -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, '下载' + '.' + 'png')
      } else if (ua.indexOf('Firefox') > -1) {
        // 火狐兼容下载
        const blob = this.base64ToBlob(imgURL) // new Blob([content]);
        a.download = ' ' // 下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob)
        a.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            })
        ) // 兼容火狐
      } else {
        // 谷歌兼容下载
        img.src = myCanvas[0].toDataURL('image/jpg')
        a.href = img.src
        // console.log(a.href);
        // 设置下载文件的名字
        a.download = row.name
        // 点击
        // a.click();
        var canvasjson = codejsmb.json
        // console.log(canvasjson);
        // if (row.Address != null && row.Address != "") {
        //   canvasjson.objects[8].text = row.Address;
        // } else {
        //   canvasjson.objects[8].text = "";
        // }
        // if (row.TouchTel != null && row.TouchTel != "") {
        //   canvasjson.objects[7].text = row.TouchTel;
        // } else {
        //   canvasjson.objects[7].text = "";
        // }
        canvasjson.objects[2].text = row.name
        canvasjson.objects[4].text = row.locationName
        // canvasjson.objects[6].text = row.name;
        // canvasjson.objects[7].text = row.TouchTel;
        canvasjson.objects[1].src = a.href
        canvasjson.objects[0].src = this.bgImage
        that.canvasObj.loadFromJSON(canvasjson, function (res) {
          var MIME_TYPE = 'image/png'
          var imgURLBg = that.canvasObj.toDataURL(MIME_TYPE, 1)

          var dlLink = document.createElement('a')
          var filename = row.name + new Date().getTime() + '.png'
          dlLink.download = filename
          dlLink.href = imgURLBg
          dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':')
          document.body.appendChild(dlLink)
          that.imgURLBg = imgURLBg // 存储为字符串 URL
          that.QRCodeURL.push(that.imgURLBg) // 存储为字符串 URL

          // console.log('QRCodeURL after push:', that.QRCodeURL) // 添加调试日志

          if (that.piLiang) {
            dlLink.click()
            document.body.removeChild(dlLink)
          }
        })
      }
    },
    // 批量生成二维码时创建压缩文件
    batchQrCodeZip() {
      const zip = new JSZip() // 新建一个压缩文件
      const _this = this
      const promises = []

      for (const key in this.QRCodeURL) {
        if (this.QRCodeURL.hasOwnProperty(key)) {
          console.log(key)

          const url = this.QRCodeURL[key] // 确保 url 是字符串
          if (typeof url === 'string') {
            const promise = _this.getFile(url).then((data) => {
              // 根据二维码图片地址下载文件, 并存成ArrayBuffer对象
              const fileName = this.faBIds[key].name + '.png' // 使用文件名作为压缩包中的文件名
              zip.file(fileName, data, {binary: true}) // 逐个添加文件，需要加后缀".png"
            })
            promises.push(promise)
          } else {
            console.error('QRCodeURL 中包含非字符串元素:', url)
          }
        }
      }

      Promise.all(promises)
          .then(() => {
            zip.generateAsync({type: 'blob'}).then((content) => {
              // 生成二进制流
              FileSaver.saveAs(content, '巡检点二维码.zip') // 利用file-saver保存文件  自定义文件名
            })
          })
          .catch((res) => {
            console.log(res)
          })
    },

    // 根据二维码图片地址下载二维码
    getFile(url) {
      return new Promise((resolve, reject) => {
        // 清空 axios 的默认 baseURL
        axios.defaults.baseURL = null // 或者 axios.defaults.baseURL = '';
        axios({
          method: 'get',
          url,
          responseType: 'blob',
        })
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error.toString())
            })
      })
    },
  },
}
</script>
<style lang="less" scoped></style>
